export default "__VITE_ASSET__jymeFjGr__"